import { Link } from 'react-router-dom';
import type { MangaItem } from '@/mocks/manga';

interface MangaCardProps {
  manga: MangaItem;
}

export default function MangaCard({ manga }: MangaCardProps) {
  return (
    <Link
      to={`/article/${manga.id}`}
      className="group block cursor-pointer"
    >
      <div className="relative overflow-hidden rounded-lg aspect-[5/7] bg-background-200 mb-3">
        <img
          src={manga.coverImage}
          alt={manga.title}
          title={`${manga.title} - 本子网站在线漫画`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs font-medium bg-primary-500/90 px-2.5 py-1 rounded-full whitespace-nowrap">
            立即阅读
          </span>
        </div>
        {manga.status === 'ongoing' && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-50 text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            连载中
          </span>
        )}
        {manga.status === 'completed' && (
          <span className="absolute top-2 left-2 bg-secondary-500 text-background-50 text-[10px] font-medium px-2 py-0.5 rounded-full whitespace-nowrap">
            已完结
          </span>
        )}
      </div>
      <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 font-heading">
        {manga.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">{manga.author}</p>
      <div className="flex items-center gap-3 mt-1.5">
        <span className="flex items-center gap-1 text-xs text-accent-600">
          <i className="ri-star-fill text-[10px]"></i>
          {manga.rating}
        </span>
        <span className="text-xs text-foreground-400">
          {manga.chapters}话
        </span>
      </div>
    </Link>
  );
}